export const LAST_SEARCH_KEY = "ih_last_search_snapshot";

function parseEntry(raw) {
	if (!raw) return null;
	try {
		return JSON.parse(raw);
	} catch {
		return null;
	}
}

export function saveSearchCache({results, params}) {
	const payload = {results: results ?? [], params};
	try {
		sessionStorage.setItem(LAST_SEARCH_KEY, JSON.stringify(payload));
	} catch (error) {
		console.warn("Search storage is completely full: ", error);
	}
}

export function loadSearchCache() {
	return parseEntry(sessionStorage.getItem(LAST_SEARCH_KEY));
}

export function hasSearchCache() {
	return Boolean(loadSearchCache()?.params);
}

export function clearSearchCache() {
	try {
		sessionStorage.removeItem(LAST_SEARCH_KEY);
	} catch (error) {
		console.warn("Failed to clear search storage: ", error);
	}
}
